import { createFileRoute, notFound } from "@tanstack/react-router";
import { FuncionalidadesModuloPage } from "@/components/pages/FuncionalidadesModuloPage";
import { FEATURE_MODULES, allModuleFaqs, findModule } from "@/lib/features-data";
import { breadcrumbLd, faqLd, ldScripts, webPageLd } from "@/lib/seo-jsonld";

const SITE = "https://kentro.com.br";

export const Route = createFileRoute("/funcionalidades/$modulo")({
  beforeLoad: ({ params }) => {
    if (!findModule(params.modulo)) throw notFound();
  },
  loader: ({ params }) => {
    const mod = findModule(params.modulo)!;
    return { mod };
  },
  head: ({ params, loaderData }) => {
    const mod = loaderData?.mod ?? findModule(params.modulo);
    if (!mod) {
      return {
        meta: [
          { title: "Funcionalidade não encontrada — Kentro" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const url = `${SITE}/funcionalidades/${mod.slug}`;
    return {
      meta: [
        { title: mod.metaTitle },
        { name: "description", content: mod.metaDesc },
        { property: "og:title", content: mod.metaTitle },
        { property: "og:description", content: mod.metaDesc },
        { property: "og:url", content: url },
        { property: "og:locale", content: "pt_BR" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "pt-BR", href: url },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: ldScripts(
        breadcrumbLd([
          { name: "Início", path: "/" },
          { name: "Funcionalidades", path: "/funcionalidades" },
          { name: mod.title, path: `/funcionalidades/${mod.slug}` },
        ]),
        webPageLd({ url, name: mod.metaTitle, description: mod.metaDesc }),
        faqLd(allModuleFaqs(mod)),
        {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: `Funcionalidades — ${mod.title}`,
          itemListElement: mod.features.map((f, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: f.title,
            item: `${url}#${f.slug}`,
          })),
        },
      ),
    };
  },
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-4 py-24 text-center">
      <h1 className="text-3xl font-bold">Módulo não encontrado</h1>
      <p className="mt-3 text-muted-foreground">
        Confira os módulos disponíveis em /funcionalidades.
      </p>
    </div>
  ),
  component: FuncionalidadesModuloRoute,
});

function FuncionalidadesModuloRoute() {
  const { mod } = Route.useLoaderData();
  return <FuncionalidadesModuloPage mod={mod} />;
}

// Referência estática para permitir prerender por módulo (opcional).
export const _MODULES = FEATURE_MODULES;
